import { render, staticRenderFns } from "./DropdownMenuItem.vue?vue&type=template&id=df2af72a&"
import script from "./DropdownMenuItem.vue?vue&type=script&lang=js&"
export * from "./DropdownMenuItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports